// ML001-F0219 (credit application policy, WebUI #170). credit_policy.get and credit_policy.set through Core's Service Link Pass-through relay:
// POST /api/v1/orgs/:orgId/modules/ledger/messages with the closed envelope { relay_version: 1, type, payload }. Core's manifest
// (core-agw112 cslptManifest.ts) gates the two types: get is ledger_manage at SAL 3 with no key; set is ledger_manage at SAL 4 with a
// required Idempotency-Key and a Core audit row. `payload` is the Spec body, forwarded unread: CreditPolicyGetBody { level, user_id?,
// credit_note_id? } (user_id is a NumericId string) and CreditPolicySetBody { level, user_id?, credit_note_id?, changes, reason }.
// Answers: data.payload is the Ledger's tunnel payload { binding_generation, orgId, organisationUuid, data: { credit_policy } } (get) or
// data: { credit_policy, changed, replayed } (set). Spec core-ledger-account-gateway 1.12.0, digest 07449a8c (pinned).
import api from './api';

const messagesPath = (orgId) => `/v1/orgs/${encodeURIComponent(orgId)}/modules/ledger/messages`;
const envelope = (type, payload) => ({ relay_version: 1, type, payload });

export const creditPolicyApi = {
  get: (orgId, query) => api.post(messagesPath(orgId), envelope('credit_policy.get', query)),
  set: (orgId, body, idempotencyKey) => api.post(
    messagesPath(orgId),
    envelope('credit_policy.set', body),
    { headers: { 'Idempotency-Key': idempotencyKey } },
  ),
};
